import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const biteCategoryApi = {
  getAll: () => axiosClient.get(ENDPOINTS.biteCategories.list).then(unwrap),
  create: (categoryName) =>
    axiosClient.post(ENDPOINTS.biteCategories.create, { categoryName }).then(unwrap),
  update: (id, categoryName) =>
    axiosClient.put(ENDPOINTS.biteCategories.update(id), { categoryName }).then(unwrap),
  setStatus: (id, status) =>
    axiosClient.patch(ENDPOINTS.biteCategories.status(id), null, { params: { status } }).then(unwrap),
  remove: (id) => axiosClient.delete(ENDPOINTS.biteCategories.delete(id)).then(unwrap),
};
